module.exports = __webpack_public_path__ + "static/media/Spark_RadiusCsv.f521b437.csv";